<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <!-- {{ race_class_obj }} -->
    <div class="w100">
      <div class="row mb-3">
        <div class="col-4">
          <label for="Label" class="form-label">名称</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder="名称"
            v-model="race_class_obj.label"
          />
        </div>
        <div class="col-4">
          <label for="RaceClassCd" class="form-label">クラスコード</label>
          <input
            type="text"
            class="form-control"
            id="Race_classCd"
            placeholder="コード"
            v-model="race_class_obj.class_cd"
          />
        </div>
        <div class="col-2">
          <label for="Sort" class="form-label">sort</label>
          <input
            type="number"
            class="form-control"
            id="Sort"
            placeholder="ソート"
            v-model="race_class_obj.sort"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-3 mb-2">
          <label for="LicenseEvent" class="form-label">競技種目</label>
          <div class="input-group">
            <bs-select
              :options="license_event_list"
              v-model="race_class_obj.license_event_id"
              :null-option="true"
              :classParam="'form-select'"
            ></bs-select>
          </div>
        </div>
        <!-- <div class="col-3 mb-2">
          <label for="RaceType" class="form-label">格式</label>
          <div class="input-group">
            <bs-select
              :options="race_type_list"
              v-model="race_class_obj.race_type_id"
              :null-option="true"
              :classParam="'form-select'"
            ></bs-select>
          </div>
        </div> -->
      </div>
      <div class="row mb-3">
        <label for="License" class="form-label">ライセンス</label>
        <div class="col-12 mb-2">
          <div
            class="d-inline-block me-2 mb-2"
            v-for="license in license_list_filter"
            :key="license"
          >
            <button
              :class="attach_license_class(license.id)"
              @click="input_check_obj(license.id)"
            >
              {{ license.label }}
            </button>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <label for="License" class="form-label">シリーズ</label>
        <div class="col-12 mb-2">
          <p class="alert alert-warning">
            シリーズはシリーズマスタから設定を行って下さい。<br />下記シリーズ名から設定へ進めます。
          </p>
        </div>
        <div class="col-12 mb-2">
          <div
            class="d-inline-block me-2 mb-2"
            v-for="series in race_class_obj.series"
            :key="series"
          >
            <button
              class="btn btn-warning"
              @click="go_series(series.series_id)"
            >
              {{ series.series_label }}
            </button>
          </div>
        </div>
      </div>
      <div class="mb-5"></div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div class="col-12 col-sm-4 mb-2 text-center">
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import '../../assets/bootstrap/css/sc.css';
import config from '../../../const'

export default {
  name: 'RaceClassDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: 'クラスマスタデータ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      race_class_obj: {},

      license_event_cd_obj: [],
      race_type_cd_obj: [],
      license_cd_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async input_check_obj(target_id) {
      const tmps = { ...this.race_class_obj }
      const tmp_license = tmps.license
      if (this.attach_license(target_id) == true) {
        const idx = tmp_license.findIndex(
          license => parseInt(target_id) == parseInt(license.license_id)
        )
        tmp_license.splice(idx, 1)
      } else {
        tmp_license.push({
          id: 0,
          license_id: target_id,
          class_id: this.not_add ? this.targetid : 0
        })
      }
      tmps.license = tmp_license
      this.race_class_obj = tmps
    },
    async loadRaceClassObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_class_data/lists',
        params
      )
        .then(async response => {
          console.log('loadType', response)
          this.race_class_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.race_class_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async update() {
      const params = this.race_class_obj

      const post_url = this.not_add
        ? config.BASE_API_URL + '/race_class_data/edit/' + this.targetid
        : config.BASE_API_URL + '/race_class_data/add'
      let result = true
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('update race_class_data response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.alertMessage = this.btnLabel + 'しました'
            this.alertClass = 'alert-success'
            this.targetid = response.data.body.id
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
            if (typeof response.data.alert.error_obj === 'object') {
              const tmp_error = { ...this.member_error_obj }
              Object.keys(response.data.alert.error_obj).forEach(key => {
                tmp_error[key] = response.data.alert.error_obj[key]
              })
              this.race_class_obj = tmp_error
            }
          } else {
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) await this.loadRaceClassObj()
          this.$forceUpdate()
          alert(this.alertMessage + ':' + result + ':' + this.targetid)
        })
    },
    go_series(series_id) {
      this.$router.push({ path: '/race_series/' + series_id })
    },
    back() {
      this.$router.go(-1)
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_event_cd_obj', err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceTypeCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_type_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceTypeCdList response', response)
          this.race_type_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.race_type_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    }
  },
  computed: {
    ...mapState({}),
    not_add: function () {
      return this.targetid != 'add' && !Number.isNaN(this.targetid)
        ? true
        : false
    },
    attach_license: function () {
      const selected = this.race_class_obj.license
      return function (license_id) {
        if (
          selected.find(sel => parseInt(sel.license_id) == parseInt(license_id))
        ) {
          return true
        }
        return false
      }
    },
    attach_license_class: function () {
      const attach = this.attach_license
      return function (license_id) {
        if (attach(license_id)) {
          return 'btn btn-warning'
        } else {
          return 'btn btn-light btn-outline-secondary'
        }
      }
    },
    license_list_filter: function () {
      if ((this.race_class_obj || {}).license_event_id > 0) {
        return this.license_list.filter(
          license =>
            license.license_event_cd == this.race_class_obj.license_event_id &&
            license.license_category == 1
        )
      }
      return []
    },
    license_list: function () {
      return this.license_cd_obj
    },
    license_event_list: function () {
      return this.license_event_cd_obj
    },
    race_type_list: function () {
      return this.race_type_cd_obj
    }
  },

  async created() {
    await this.loadLicenseCdList()
    await this.loadLicenseEventCdList()
    await this.loadRaceTypeCdList()
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadRaceClassObj()
      this.btnLabel = '更新'
    } else {
      this.race_class_obj = {
        id: 0,
        label: '',
        class_cd: '',
        license_event_id: '',
        race_type_id: '',
        license: [],
        sort: 0
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = 'クラスマスタデータ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
